import { Result } from '@xlearn/common'
import { StateSerializerName } from './state-serialization-plugin'
import { SerializerError } from './state-serializer'
import { DeserializerError } from './state-deserializer'

export interface SerializeResult {
  buffer: Uint8Array,
  serializerId: number
}

export interface DeserializeResult<T> {
  content: T,
  serializerName: StateSerializerName
}

export const TypedStateSerializerSymbol = Symbol.for('TypedStateSerializer')
export interface TypedStateSerializer {
  serialize<T>(name: StateSerializerName, format: string,
               state: T): Result<SerializeResult, TypedStateSerializeError>
  deserialize<T>(nameOrId: StateSerializerName | number,
                 format: string,
                 buffer: Uint8Array): Result<DeserializeResult<T>, TypedStateDeserializeError>
}

export type TypedStateSerializeError = SerializerNotFoundError
      | { code: 'serialize-error', details: SerializerError }

export type TypedStateDeserializeError = SerializerNotFoundError
      | { code: 'deserialize-error', details: DeserializerError }

export type SerializerNotFoundError = { code: 'serializer-not-found', details: StateSerializerName | number }
